// services/purchases/CreditNoteLookupService.ts
import { CreditNoteLookupFilter, SelectOption } from '../../types/purchases/CreditNoteLookup';
import { ApiResponse } from '../../types/common/ApiResponse';
import { creditNoteLookupApi } from '../../api';

const CreditNoteLookupService = {
  /**
   * POST /api/credit-note-lookup/purchases/search
   */
  searchEligiblePurchases: async (
    filters: CreditNoteLookupFilter
  ): Promise<ApiResponse<SelectOption[]>> => {
    const response = await creditNoteLookupApi.addCustom('/purchases/search', filters);
    return response.data;
  },

  /**
   * GET /api/credit-note-lookup/products/{purchaseId}
   */
  getProductsByPurchase: async (
    purchaseId: number
  ): Promise<ApiResponse<SelectOption[]>> => {
    const response = await creditNoteLookupApi.fetchCustom(`/products/${purchaseId}`);
    return response.data;
  },
};

export default CreditNoteLookupService;
